import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('REPORT').plugin(axiosPlugin);

let createReportAction = redux.fetchActionCreate();

export const TYPES = redux.types;

export const reportForumTopic = (forumId, topicId, data = {}) => createReportAction(`/forums/${forumId}/topics/${topicId}/reporting`, data);
export const reportForumComment = (forumId, topicId, commentId, data = {}) => createReportAction(`/forums/${forumId}/topics/${topicId}/comments/${commentId}/reporting`, data);

export const reportMediaComment = (mediaId, commentId, data = {}) => createReportAction(`/medias/${mediaId}/comments/${commentId}/reporting`, data);
export const reportArticleComment = (articleId, commentId, data = {}) => createReportAction(`/articles/${articleId}/comments/${commentId}/reporting`, data);
// export const reportStatusComment = (userId, statusId, commentId, data = {}) => createReportAction(`/users/${userId}/status/${statusId}/comments/${commentId}/reporting`, data);
export const reportStatusComment = (statusId, commentId, data = {}) => createReportAction(`/status/${statusId}/comments/${commentId}/reporting`, data);
export const reportSubComment = (type, parentId, commentId, subCommentId, data = {}) => createReportAction(`/${type}/${parentId}/comments/${commentId}/subcomments/${subCommentId}/reporting`, data);

export const reportMedia = (mediaId, data = {}) => createReportAction(`/medias/${mediaId}/reporting`, data);
export const reportAlbum = (albumId, data = {}) => createReportAction(`/albums/${albumId}/reporting`, data);

export const reportUserStatus = (statusId, data = {}) => createReportAction(`/status/${statusId}/reporting`, data);

export const reportUser = (userId, data = {}) => createReportAction(`/users/${userId}/reporting`, data);

export const reportArticle = (articleId, data = {}) => createReportAction(`/articles/${articleId}/reporting`, data);

export const report = redux.reducer();